"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateCacheOnVideoWatched = exports.VIDEO_WATCHED = void 0;
const client_1 = require("@apollo/client");
const fragments_1 = require("../../fragments");
const osce_1 = require("../../query/restricted/osce");
exports.VIDEO_WATCHED = (0, client_1.gql) `
  mutation VideoWatched($id: Int!) {
    restricted {
      videoWatched(id: $id) {
        id
        views
        viewsToday
      }
    }
  }
`;
const updateCacheOnVideoWatched = (entitlementId) => (cache, result) => {
    const { videoWatched } = result?.data?.restricted || {};
    if (!videoWatched) {
        return;
    }
    const { id } = videoWatched;
    cache.writeFragment({
        id: cache.identify({ id, __typename: 'Video' }),
        data: {
            userViewed: true,
        },
        fragment: fragments_1.VIDEO_USER_VIEWED_FRAGMENT,
    });
    if (entitlementId) {
        const prevOsceStats = cache?.readQuery({
            query: osce_1.OSCE_STATS,
            variables: { solo: true },
        });
        if (prevOsceStats) {
            const { completed, types } = prevOsceStats.restricted.osceStats;
            cache.writeQuery({
                query: osce_1.OSCE_STATS,
                data: {
                    ...prevOsceStats,
                    restricted: {
                        ...prevOsceStats.restricted,
                        osceStats: {
                            ...prevOsceStats.restricted.osceStats,
                            completed: Number(completed) + 1,
                            types: types?.map(({ id, completed, ...rest }) => ({
                                id,
                                completed: Number(id) === Number(entitlementId)
                                    ? Number(completed) + 1
                                    : completed,
                                ...rest,
                            })),
                        },
                    },
                },
            });
        }
    }
};
exports.updateCacheOnVideoWatched = updateCacheOnVideoWatched;
